// extracted by mini-css-extract-plugin
export default {"taskListWrapper":"task-list-table_taskListWrapper__gf6ym"};